import AssignedJourneyCard from './container';

export default AssignedJourneyCard;
